module.exports = __webpack_public_path__ + "img/question_center_bg.7eed9bb3.png";